import axios from 'axios';

const url = process.env.VUE_APP_ROLEAPI;
const home = process.env.VUE_APP_HOME;

const getRole = async function (){

    let auth = localStorage.getItem('scientia-session-authorization');

    let access_token = "";

    if (!auth)
    {
        access_token = process.env.VUE_APP_TOKEN;
    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }

  //  if (!access_token) window.location = home;

    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`,
           'Content-Type': 'application/json'
        }
    };
    let urlWithArg = url + 'api/Role';

    let result = await axios.get(urlWithArg, headers);
    
    return result.data;

}


const postRole = async function (payload){

    let auth = localStorage.getItem('scientia-session-authorization');

    let access_token = "";

    if (!auth)
    {
        access_token = process.env.VUE_APP_TOKEN;
    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }

  //  if (!access_token) window.location = home;

    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`,
           'Content-Type': 'application/json'
        }
    };
    let urlWithArg = url + 'api/Role';

    let result = await axios.post(urlWithArg, payload, headers);
    
    return result.data;

}


const updateRole = async function (payload){

    let auth = localStorage.getItem('scientia-session-authorization');

    let access_token = "";

    if (!auth)
    {
        access_token = process.env.VUE_APP_TOKEN;
    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }

  //  if (!access_token) window.location = home;

    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`,
           'Content-Type': 'application/json'
        }
    };
    let urlWithArg = url + 'api/Role/'+payload.Identity;

    let result = await axios.put(urlWithArg, payload, headers);
    
    return result.data;

}

const deleteRole = async function (id){

    let auth = localStorage.getItem('scientia-session-authorization');

    let access_token = "";

    if (!auth)
    {
        access_token = process.env.VUE_APP_TOKEN;
    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }

  //  if (!access_token) window.location = home;

    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`,
           'Content-Type': 'application/json'
        }
    };
    let urlWithArg = url + 'api/Role/'+id;

    let result = await axios.delete(urlWithArg, headers);
    
    return result.data;

}

const getRoleDetail = async function (id){

    let auth = localStorage.getItem('scientia-session-authorization');

    let access_token = "";

    if (!auth)
    {
        access_token = process.env.VUE_APP_TOKEN;
    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }

  //  if (!access_token) window.location = home;

    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`,
           'Content-Type': 'application/json'
        }
    };
    let urlWithArg = url + 'api/Role/'+id+'/detail';

    let result = await axios.get(urlWithArg, headers);
    
    return result.data;

}


const updateRoleDetail = async function (payload){

    let auth = localStorage.getItem('scientia-session-authorization');

    let access_token = "";

    if (!auth)
    {
        access_token = process.env.VUE_APP_TOKEN;
    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }

  //  if (!access_token) window.location = home;

    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`,
           'Content-Type': 'application/json'
        }
    };
    let urlWithArg = url + 'api/Role/'+payload.roleIdentity+'/detail';

    let result = await axios.put(urlWithArg, payload, headers);
    
    return result.data;

}



export const roleService = { getRole, postRole, updateRole, deleteRole, getRoleDetail, updateRoleDetail }


// WEBPACK FOOTER //
// ./src/api/role-service.js